import React from 'react'
import { useTranslation } from 'react-i18next'

import { eventLogger } from '~/shared/services/eventLogger'

export const PrivacyPolicyLink: React.FC = () => {
  const { t } = useTranslation()

  return (
    <a
      href="https://quiz.mygrowth.one/privacy-policy#"
      onClick={() => eventLogger.logPrivacyPolicyClicked()}
      target="_blank"
      rel="noopener noreferrer"
    >
      {t`commonComponents.privacyPolicy`}
    </a>
  )
}
